import DefaultLayout from "@/components/DefaultLayout";
import styles from "@/styles/secondaryPage/newsletters.module.scss";
import {
  Image,
  Form,
  Input,
  Button,
  DatePicker,
  Row,
  Col,
  Table,
  message,
} from "antd";
import subscribeApi from "@/service/modules/myAccountApi";
import { useEffect, useState } from "react";
import productApi from "@/service/modules/productApi";
import GiftSvg from "@/svgs/gift.svg";
import Head from "next/head";
import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
const imageDomain = publicRuntimeConfig.imageDomain;
import { useRouter } from "next/router";

export default function Newsletters() {
  const [prizeArr, setPrizeArr] = useState([]);
  const [termsObj, setTermsObj] = useState({ title: "", items: [] });
  const [newsletterContentObj, setNewsletterContentObj] = useState({
    content: "",
    img: "",
    title: "",
  });
  const [winners, setWinners] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const router = useRouter();
  const [form] = Form.useForm();

  useEffect(() => {
    const { email } = router.query;
    if (!email) return;
    form.setFieldsValue({ email });
  }, [router]);
  useEffect(() => {
    getSubscribeInfo();
  }, []);

  const getSubscribeInfo = async () => {
    try {
      let res = await subscribeApi.subscribeInfo();

      if (res.data) {
        const { prize, terms, winners, newsletterContent } = res.data;
        prize && setPrizeArr(prize);
        terms && setTermsObj(terms);
        winners &&
          setWinners(
            winners.map((v: any, index: any) => {
              return { ...v, index: index };
            })
          );
        newsletterContent && setNewsletterContentObj(newsletterContent);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      title: "Month",
      dataIndex: "month",
      align: "center" as "center",
    },
    {
      title: "Name",
      dataIndex: "name",
      align: "center" as "center",
    },
    {
      title: "Prize",
      dataIndex: "prize",
      align: "center" as "center",
    },
    {
      title: "Remark",
      dataIndex: "content",
      align: "center" as "center",
    },
  ];

  const defaultCaptcha = {
    img: "",
    key: "",
  };
  const [captcha, setCaptcha] = useState(defaultCaptcha);
  const generate = async () => {
    try {
      const res = await productApi.generate();
      const { captcha } = res.data;
      setCaptcha(captcha);
    } catch (error: any) {
      message.error(error.message);
    }
  };

  const onFinish = (fieldsValue: any) => {
    setBtnLoading(true);
    const { email, month, year } = fieldsValue;
    const params = {
      email: email,
      birthm: month ? month.format("MM") : "",
      birthy: year ? year.format("YYYY") : "",
      captcha: fieldsValue.captcha,
      key: captcha.key,
    };
    subscribe(params);
  };

  const subscribe = async (params: any) => {
    try {
      setBtnLoading(false);
      const res = await subscribeApi.subscribe(params);
      const { location } = res.data;
      if (location) {
        window.location.href = location;
      }
    } catch (error: any) {
      setBtnLoading(false);
      message.error(error.message);
      if (captcha && captcha.img) {
        generate();
      }
      // 出验证码
      if (error.code == 100065) {
        generate();
      }
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  type FieldType = {
    email?: string;
    month?: string;
    day?: string;
  };

  return (
    <>
      <Head>
        <title>
          Subscribe Crazysales Newsletters to Win $100 Voucher -
          Crazysales.com.au
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="Subscribe Crazysales newsletters and get the latest notification of greats deals and discounts of Crazy Sales! You can win $100 voucher for subscription."
        ></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-title" content="Crazy Sales" />
      </Head>
      <DefaultLayout notStickyNavbar={true}>
        <div className={styles["newsletters-box"]}>
          <div className={styles["banner-box"]}>
            <Image
              width={"100%"}
              src={newsletterContentObj.img}
              preview={false}
              alt="Crazy Sales Newsletters"
            />
          </div>
          <div
            className={styles["main"]}
            style={{
              backgroundImage: `url(${imageDomain}/newsletters/subscribe-2-bg.png)`,
            }}
          >
            <div className={styles["form-box"]}>
              <div className={styles["title"]}>
                {newsletterContentObj.title}{" "}
              </div>
              <div
                className={styles["desc"]}
                dangerouslySetInnerHTML={{
                  __html: newsletterContentObj.content,
                }}
              >
                {/* Subscribe to Our Newsletter for a Chance to
                <br />Win iPhone 14 Pro Max now ! */}
              </div>

              <div className={styles["forms"]}>
                <div className={styles["form-title"]}>Required Information</div>
                <Form
                  className={styles["my-forms"]}
                  form={form}
                  name="basic"
                  layout="vertical"
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                >
                  <Form.Item<FieldType>
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: "Please input your email!" },
                      { type: "email" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <div style={{ paddingBottom: "8px" }}>
                    DOB (You may receive a birthday gift from us!)
                  </div>
                  <Row gutter={24} justify="space-between">
                    <Col span={12}>
                      <Form.Item<FieldType>
                        label=""
                        name="month"
                        // rules={[
                        //   { required: true, message: 'Please select your month!' },
                        //   ({ getFieldValue }) => ({
                        //     validator(_, value) {
                        //       if (!!getFieldValue('year')) {
                        //         return Promise.resolve();
                        //       }
                        //       return Promise.reject(new Error('Please select your year!'));
                        //     },
                        //   })
                        // ]}
                      >
                        <DatePicker
                          mode="month"
                          picker="month"
                          format="MM"
                          style={{ width: "100%" }}
                          popupClassName={styles["monthDatePicker"]}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item<FieldType> label="" name="year">
                        <DatePicker
                          picker="year"
                          format="YYYY"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  {captcha.img && (
                    <>
                      <Form.Item<FieldType> label="To Generate New Code, Click Picture:">
                        <Image
                          src={captcha.img}
                          preview={false}
                          alt="code-image"
                          width={120}
                          height={35}
                          style={{ cursor: "pointer" }}
                          onClick={generate}
                        />
                      </Form.Item>

                      <Form.Item<FieldType>
                        label="Input Confirmation Code:"
                        name="captcha"
                        rules={[
                          { required: true, message: "please input your code" },
                        ]}
                      >
                        <Input placeholder="Code" />
                      </Form.Item>
                    </>
                  )}

                  <Form.Item wrapperCol={{ span: 24 }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={btnLoading}
                      style={{ width: "100%" }}
                    >
                      Subscribe Now!
                    </Button>
                  </Form.Item>
                </Form>

                <div className={styles["unsubscribe"]}>
                  You can unsubscribe at anytime ！
                  <Button
                    className={styles["unsubscribe-btn"]}
                    href="/newsletters/frontpreunsub"
                    type="link"
                  >
                    click here
                  </Button>
                </div>
              </div>

              {prizeArr && prizeArr.length > 0 ? (
                <div className={styles["playing-method"]}>
                  {prizeArr.map((item: any, index: number) => (
                    <div className={styles["playing-items"]} key={index}>
                      <div className={styles["icon"]}>
                        <GiftSvg />
                      </div>
                      <div className={styles["item-name"]}>{item}</div>
                    </div>
                  ))}
                </div>
              ) : null}

              {/* 样式暂时用不上了，直接用富文本样式 */}
              {termsObj &&
              termsObj.title &&
              termsObj.items &&
              termsObj.items.length > 0 ? (
                <div className={styles["subscribe-detail"]}>
                  <div className={styles["detail-title"]}>{termsObj.title}</div>
                  {termsObj.items.map((item: any, index: number) => (
                    <div className={styles["question-item"]} key={index}>
                      <div className={styles["question"]}>{item.title}</div>
                      <div className={styles["answer"]}>{item.content}</div>
                    </div>
                  ))}
                </div>
              ) : null}

              {winners && winners.length > 0 ? (
                <div className={styles["subscribe-table"]}>
                  <div className={styles["table-title"]}>Past Winners</div>
                  <Table
                    className={styles["my-table-newsletters-winner"]}
                    columns={columns}
                    dataSource={winners}
                    pagination={false}
                    bordered
                    rowKey="index"
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  );
}
